/* Careers page (sections/zev-careers.liquid). Source: marketing_module/shopify/theme/careers/
   in the DataVault repo. Roles and the form go to DataVault's /api/public/careers/*. */
(function () {
  var root = document.getElementById('zcr');
  if (!root) return;
  var API = (root.getAttribute('data-api') || 'https://widget.zevpoint.com').replace(/\/$/, '');
  var params = new URLSearchParams(location.search);
  var KEY = 'zv_careers_ref';

  // An employee's ?ref= is kept for 30 days, so a visitor who comes back
  // later to apply is still credited to them.
  var ref = (params.get('ref') || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 12);
  try {
    if (ref) localStorage.setItem(KEY, JSON.stringify({ code: ref, at: Date.now() }));
    else {
      var kept = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (kept && Date.now() - kept.at < 30 * 864e5) ref = kept.code;
    }
  } catch (e) { /* storage blocked: the link's own ?ref= still works */ }
  var job = (params.get('job') || '').slice(0, 80);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function roleCard(o, focus) {
    var meta = [o.location, o.salary].filter(Boolean).map(esc).join(' · ');
    return '<article class="zcr-role' + (focus ? ' is-focus' : '') + '">' +
      '<h3>' + esc(o.title) + '</h3>' + (meta ? '<p class="zcr-meta">' + meta + '</p>' : '') +
      (o.summary ? '<p class="zcr-sum">' + esc(o.summary) + '</p>' : '') +
      '<a class="zcr-btn zcr-btn--line" href="#apply" data-job="' + esc(o.slug) + '">Apply for this role</a></article>';
  }

  function render(data) {
    var roles = data.openings.slice();
    if (data.job && !roles.some(function (o) { return o.slug === data.job.slug; })) roles.unshift(data.job);
    var box = document.getElementById('zcr-roles');
    box.innerHTML = roles.length
      ? roles.map(function (o) { return roleCard(o, data.job && o.slug === data.job.slug); }).join('')
      : '<p class="zcr-muted">' + document.getElementById('zcr-empty').innerHTML + '</p>';
    var sel = document.getElementById('zcr-job');
    roles.forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o.slug; opt.textContent = o.title;
      sel.appendChild(opt);
    });
    if (data.job) sel.value = data.job.slug;
    if (data.referrer) {
      var r = document.getElementById('zcr-ref');
      r.textContent = 'Referred by ' + data.referrer + ' at Zevpoint.';
      r.hidden = false;
      document.getElementById('zcr-refby').hidden = true;
    }
  }

  document.getElementById('zcr-refcode').value = ref;
  fetch(API + '/api/public/careers/openings?' + new URLSearchParams({ job: job, ref: ref }))
    .then(function (r) { return r.json(); })
    .then(function (d) { if (d && d.success) render(d); })
    .catch(function () {
      document.getElementById('zcr-roles').innerHTML = '<p class="zcr-muted">Could not load the roles. You can still apply below.</p>';
    });

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-job]');
    if (a) document.getElementById('zcr-job').value = a.getAttribute('data-job');
  });

  var form = document.getElementById('zcr-form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = document.getElementById('zcr-err');
    var btn = form.querySelector('button[type=submit]');
    err.textContent = '';
    var f = form.elements;               // form.name is the form's own attribute
    if (!f['name'].value.trim()) { err.textContent = 'Please enter your name.'; return; }
    if (f['phone'].value.replace(/\D/g, '').length < 10) { err.textContent = 'Please enter a 10-digit mobile number.'; return; }
    if (!f['consent'].checked) { err.textContent = 'Please tick the consent box.'; return; }
    btn.disabled = true;
    fetch(API + '/api/public/careers/apply', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.success) throw new Error(d.error || 'Something went wrong.');
        form.hidden = true;
        document.getElementById('zcr-done').hidden = false;
        try { localStorage.removeItem(KEY); } catch (x) { /* ignore */ }
      })
      .catch(function (x) { err.textContent = x.message || 'Something went wrong. Please try again.'; })
      .then(function () { btn.disabled = false; });
  });
})();
